import { render } from "./Onboardings.vue?vue&type=template&id=8ca3dfb2&ts=true"
import script from "./Onboardings.vue?vue&type=script&lang=ts"
export * from "./Onboardings.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__